import React, { useState } from "react";
import { Menu, ConfigProvider } from "antd";
import { useNavigate } from "react-router-dom";
import "./NavigationBar.css";

const items = [
  {
    label: "Home",
    key: "/sysu-software",
  },
  {
    label: "Our Project",
    key: "OurProject",
    children: [
      {
        label: <span className="submenu">Description</span>,
        key: "/sysu-software/description",
      },
      {
        label: <span className="submenu">Design</span>,
        key: "/sysu-software/design",
      },
      {
        label: <span className="submenu">Engineering</span>,
        key: "/sysu-software/engineering",
      },
      {
        label: <span className="submenu">Proof of Concept</span>,
        key: "/sysu-software/proof-of-concept",
      },
      {
        label: <span className="submenu">Contribution</span>,
        key: "/sysu-software/contribution",
      },
    ],
  },
  {
    label: "Software",
    key: "/sysu-software/software",
  },
  {
    label: "Model",
    key: "/sysu-software/model",
  },
  {
    label: "Human Practice",
    key: "HumanPractice",
    children: [
      {
        label: <span className="submenu">Integrated HP</span>,
        key: "/sysu-software/human-practices",
      },
      {
        label: <span className="submenu">Collaboration</span>,
        key: "/sysu-software/collaboration",
      },
    ],
  },
  {
    label: "Entrepreneurship",
    key: "/sysu-software/entrepreneurship",
  },
  {
    label: "Medal",
    key: "/sysu-software/medal",
  },
  {
    label: "Team",
    key: "Team",
    children: [
      {
        label: <span className="submenu">Members</span>,
        key: "/sysu-software/members",
      },
      {
        label: <span className="submenu">Attributions</span>,
        key: "/sysu-software/attributions",
      },
      {
        label: <span className="submenu">Safety</span>,
        key: "/sysu-software/safety",
      },
      {
        label: <span className="submenu">Notebook</span>,
        key: "/sysu-software/notebook",
      },
    ],
  },
];
const NavigationBar = () => {
  const navigate = useNavigate();
  const [current] = useState("mail");
  const onClick = (e) => {
    navigate(e.key, { replace: true });

    window.scrollTo(0, 0);
    // window.location.href = window.location.href;
  };
  return (
    <div className="navigation-bg">
      <img
        src="https://static.igem.wiki/teams/4826/wiki/logo.svg"
        alt="logo"
        style={{ marginLeft: "30px" }}
      ></img>
      <ConfigProvider
        theme={{
          components: {
            Menu: {
              /* here is your component tokens */
              itemColor: "#ffffff",
              horizontalLineHeight: "120px",
              dropdownWidth: "auto",
              itemBg: "rgba(0, 0, 0, 0)",
              itemHoverColor: "#ffffff",
              // itemMarginInline: "60px",
              fontSize: "16px",
              fontWeightStrong: 5,
              fontFamily: "Source Han Sans Bold",
              itemBorderRadius: "0",
              horizontalItemHoverBg: "#5837ae",
              horizontalItemHoverColor: "#605979",
              horizontalItemSelectedBg: "#5837ae",
              horizontalItemSelectedColor: "#ffffff",
              itemSelectedBg: "#cfced4",
              itemSelectedColor: "#ffffff",
              subMenuItemBorderRadius: "0",
            },
          },
        }}
      >
        <Menu
          onClick={onClick}
          selectedKeys={[current]}
          mode="horizontal"
          items={items}
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-around",
          }}
        />
      </ConfigProvider>
    </div>
  );
};
export default NavigationBar;
